// extracted by mini-css-extract-plugin
export default {"slide_list":"SlideList_slide_list__XgYFh"};